define([
	"dojo/_base/declare",
	"csi/_base/underscore"
], function(declare,_) {

	return declare(null, {
		// Object: size chart sub size ranges
		//	Integer: base (base size index for range)
		//	Integer: min (min index for range)
		// 	Integer: max (max index for range)
		//	Node: node (sub size range node)
		_ranges: null,

		// Object: mapping from dimension index to range index
		_indexMap: null,

		constructor: function(subSizeRanges) {
			var	obj = this._indexMap = {};
			var	n = 0;

			this._ranges = _.map(subSizeRanges, function(ssr, i) {
				var	min = n;
				var	nSizes = ssr.Sizes.length;

				// add indices to map for sub size range
				for (var j = 0; j < nSizes; ++j) {
					obj[n+j] = i;
				}

				n += nSizes;

				return {
					base: ssr.BaseSizeIndex,
					min: min,
					max: n-1,
					node: ssr
				};
			});
		},

		getBaseIndex: function(i) {
			return this._getRange(i).base;
		},

		getMaxIndex: function(i) {
			return this._getRange(i).max;
		},

		getMinIndex: function(i) {
			return this._getRange(i).min;
		},

		getSubSizeRange: function(i) {
			return this._getRange(i).node;
		},

		isBaseIndex: function(i) {
			return this.getBaseIndex(i) == i;
		},

		iterate: function(i, baseFunc, leftFunc, rightFunc, scope) {
			scope = scope || dojo.global;
			if (i == null) {
				for (i = 0; i < this._ranges.length; ++i) {
					this.iterate(this._ranges[i].base, baseFunc, leftFunc, rightFunc, scope);
				}
			} else {
				var	r = this._getRange(i);

				if (baseFunc) {
					baseFunc.call(scope, r.base);
				}

				if (leftFunc) {
					for (i = r.base - 1; i >= r.min; --i) {
						leftFunc.call(scope, i);
					}
				}

				if (rightFunc) {
					for (i = r.base + 1; i <= r.max; ++i) {
						rightFunc.call(scope, i);
					}
				}
			}
		},

		_getRange: function(i) {
			return this._ranges[this._indexMap[i]];
		}
	});
});